
import { InfoWindow } from "@react-google-maps/api";
import { Link } from "react-router-dom";
import { Department } from "./departmentData";

interface DepartmentInfoWindowProps {
  department: Department;
  onCloseClick: () => void;
}

const DepartmentInfoWindow = ({ department, onCloseClick }: DepartmentInfoWindowProps) => {
  return (
    <InfoWindow
      position={{ lat: department.coordinates[1], lng: department.coordinates[0] }}
      onCloseClick={onCloseClick}
    >
      <div className="p-2">
        <h3 className="font-bold">{department.name} ({department.code})</h3>
        <p>Région: {department.region}</p>
        <Link
          to={`/sites?dept=${department.code}`}
          className="text-blue-600 hover:underline"
        >
          Voir nos sites
        </Link>
      </div>
    </InfoWindow>
  );
};

export default DepartmentInfoWindow;
